<template>
  <div>
    <div v-if="!isLoading">
      <mu-card-header titleClass="boldTitle largeTitle" :title="title" :subTitle="subTitle"></mu-card-header>
      <mu-card-text>

        <reset-account v-if="!isHcpUser || !isHcpView"></reset-account>

        <avatar-uploader v-if="!isLoading"></avatar-uploader>
        <update-height></update-height>
        <!--
        <mobile-phone-input class="bottom" :value="{'dial_code': '+44', 'dial_number': '7469176669'}"></mobile-phone-input>
        -->


        <!--
                  <mobile-phone-input class="bottom" :value="{'dial_code': '+44', 'dial_number': '7469176669'}"></mobile-phone-input>
        -->


        <mu-row gutter>
          <mu-col width="100" desktop="50" tablet="50">
            <mu-text-field
              v-if="!hideNameInputs"
              v-validate="{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
              data-vv-name="firstname"
              data-vv-value-path="inputValue"
              :data-vv-as="$t('message.accountPreferencesFirstName')"
              :errorText="errors.first('firstname')"
              :fullWidth="true"
              :label="$t('message.accountPreferencesFirstName')"
              v-model="model.firstname"
            ></mu-text-field>
          </mu-col>
          <mu-col width="100" desktop="50" tablet="50">
            <mu-text-field
              v-if="!hideNameInputs"
              v-validate="{required:true, max: 40, regex: /^[a-zA-Z ]*$/}"
              data-vv-name="surname"
              data-vv-value-path="inputValue"
              :data-vv-as="$t('message.accountPreferencesSurname')"
              :errorText="errors.first('surname')"
              :fullWidth="true"
              :label="$t('message.accountPreferencesSurname')"
              v-model="model.surname"
            ></mu-text-field>
          </mu-col>

          <mu-col width="100" desktop="100" tablet="100">
            <mu-text-field
              v-if="hideNameInputs"
              v-validate
              :data-vv-rules="'required|display_name_regex|min:2|max:30'"
              data-vv-name="display_name"
              data-vv-value-path="inputValue"
              :data-vv-as="$t('message.accountPreferencesDisplayName')"
              :errorText="errors.first('display_name')"
              :fullWidth="true"
              :label="$t('message.accountPreferencesDisplayName')"
              v-model="model.display_name"
            ></mu-text-field>
          </mu-col>
          <mu-col width="100" desktop="100" tablet="100">
            <mu-row>
              <p>{{$t('Show username instead of first and last name')}}</p>
              <mu-switch v-model="model.use_display_name" @change="switchInputs"></mu-switch>
            </mu-row>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-card-text></mu-card-text>
          <mu-divider></mu-divider>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" tablet="100" desktop="100">
            <mu-row gutter>
              <mu-col width="100" desktop="100" tablet="100">
                <mu-row gutter>
                  <mu-col width="33" desktop="33" tablet="30">
                    <mu-select-field
                      autoWidth
                      :scroller="scroller"
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="birth_day"
                      data-vv-value-path="inputValue"
                      :data-vv-as="$t('message.labelDay')"
                      :errorText="errors.first('birth_day')"
                      :underlineShow="underlineShow"
                      :fullWidth="fullWidth"
                      :maxHeight="200"
                      :hintText="$t('message.selectText')"
                      v-model="dob.day"
                      :label="$t('message.accountPreferencesBirthday')">
                      <mu-menu-item
                        v-for="(item, index) in dobItems.days"
                        :key="'dob-day-' + index"
                        :value="item"
                        :title="item"
                      ></mu-menu-item>
                    </mu-select-field>
                  </mu-col>
                  <mu-col width="33" desktop="33" tablet="30">
                    <mu-select-field
                      :scroller="scroller"
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="birth_month"
                      data-vv-value-path="inputValue"
                      :data-vv-as="$t('message.labelMonth')"
                      :errorText="errors.first('birth_month')"
                      :underlineShow="underlineShow"
                      :fullWidth="fullWidth"
                      autoWidth
                      :maxHeight="200"
                      :hintText="$t('message.selectText')"
                      v-model="dob.month"
                      label=" ">
                      <mu-menu-item
                        v-for="(month, index) in dobItems.months"
                        :key="'month-' + index"
                        :value="month"
                        :title="localizeMonth(month.name)"
                      ></mu-menu-item>
                    </mu-select-field>
                  </mu-col>
                  <mu-col width="33" desktop="33" tablet="30">
                    <mu-select-field
                      :autoWidth="true"
                      :scroller="scroller"
                      v-validate
                      :data-vv-rules="'required'"
                      data-vv-name="birth_year"
                      data-vv-value-path="inputValue"
                      :data-vv-as="$t('message.labelYear')"
                      :errorText="errors.first('birth_year')"
                      :underlineShow="underlineShow"
                      :fullWidth="fullWidth"
                      :maxHeight="200"
                      :hintText="$t('message.selectText')"
                      v-model="dob.year"
                      label=" ">
                      <mu-menu-item
                        v-for="(year, index) in dobItems.years"
                        :key="'year-' + index"
                        :value="year"
                        :title="''+year.value+''"
                      ></mu-menu-item>
                    </mu-select-field>
                  </mu-col>
                </mu-row>
              </mu-col>
            </mu-row>
          </mu-col>
          <mu-col></mu-col>
        </mu-row>
        <mu-row gutter>
          <mu-col width="100" desktop="100" tablet="100">
            <mu-select-field
              :scroller="scroller"
              v-validate
              :data-vv-rules="'required'"
              data-vv-name="diabetes_type"
              data-vv-value-path="inputValue"
              :data-vv-as="$t('message.accountPreferencesWhatBringsYouHere')"
              :errorText="errors.first('diabetes_type')"
              v-model="model.diabetes_type_id"
              :maxHeight="216"
              :label="$t('message.accountPreferencesWhatBringsYouHere')"
              :fullWidth="fullWidth">
              <mu-menu-item
                v-for="(item, index) in lists.diabetes_types"
                v-if="item.hide === 0"
                :key="'diabetes-type-' + index"
                :title="localizeRegistrationReason(item.diabetes_type)"
                :value="item.diabetes_type_id"
              ></mu-menu-item>
            </mu-select-field>
          </mu-col>
          <mu-col width="100" desktop="100" tablet="100">
            <mu-select-field
              :scroller="scroller"
              v-validate
              :data-vv-rules="'required'"
              data-vv-name="diagnosis_year"
              data-vv-value-path="inputValue"
              :data-vv-as="$t('message.accountPreferencesDiagnosisYear')"
              :errorText="errors.first('diagnosis_year')"
              v-model.number="model.diagnosis_year"
              :maxHeight="216"
              :label="$t('message.accountPreferencesDiagnosisYear')"
              :fullWidth="fullWidth">
              <mu-menu-item
                v-for="(item, index) in yearList()"
                :key="'diagnosis-year+' + index"
                :title="'' + item + ''"
                :value="item"
              ></mu-menu-item>
            </mu-select-field>
          </mu-col>
        </mu-row>
        <mu-row>
          <mu-col width="100" desktop="100" tablet="100">
            <mu-select-field
              :scroller="scroller"
              v-validate
              :data-vv-rules="'required'"
              data-vv-name="gender"
              data-vv-value-path="inputValue"
              :data-vv-as="$t('message.accountPreferencesSex')"
              :errorText="errors.first('gender')"
              v-model="model.gender_id"
              :maxHeight="216"
              :label="$t('message.accountPreferencesSex')"
              :fullWidth="fullWidth">
              <mu-menu-item
                v-for="(item, index) in lists.genders"
                :key="'gender-' + index"
                :title="localizeSex(item.gender)"
                :value="item.gender_id"
              ></mu-menu-item>
            </mu-select-field>
          </mu-col>
        </mu-row>
        <mu-checkbox v-model="model.tests_blood" :label="$t('message.accountPreferencesTestBlood')"></mu-checkbox>
        <br/>
        <mu-checkbox v-model="model.takes_medication"
                     :label="$t('message.accountPreferencesTakeMedication')"></mu-checkbox>
        <br/>
        <br/>
        <mu-select-field
          autoWidth
          :scroller="scroller"
          v-validate
          :data-vv-rules="'required'"
          data-vv-name="ethnicity"
          data-vv-value-path="inputValue"
          data-vv-as="day"
          :errorText="errors.first('ethnicity')"
          :underlineShow="underlineShow"
          :fullWidth="fullWidth"
          :maxHeight="200"
          :hintText="$t('message.selectText')"
          v-model="personalizationModel.ethnicity_id"
          :label="$t('message.accountPreferencesEthnicity')">
          <mu-menu-item
            v-for="(item, index) in lists.ethnicities"
            :key="'ethnicity-' + index"
            :value="item.ethnicity_id"
            :title="$t(localizeEthnicity(item.ethnicity_id))"
          ></mu-menu-item>
        </mu-select-field>
        <mu-select-field
          autoWidth
          :scroller="scroller"
          v-validate
          :data-vv-rules="'required'"
          data-vv-name="language"
          data-vv-value-path="inputValue"
          :data-vv-as="$t('message.accountPreferencesLanguage')"
          :errorText="errors.first('language')"
          :underlineShow="underlineShow"
          :fullWidth="fullWidth"
          :maxHeight="200"
          hintText="Select"
          v-model="personalizationModel.language_id"
          :label="$t('message.accountPreferencesLanguage')">
          <mu-menu-item
            v-for="(item, index) in lists.languages"
            :key="'language-'+ index"
            :value="item.id"

            :title="getNativeName(item.iso)"
          ></mu-menu-item>
        </mu-select-field>
        <mu-select-field
          autoWidth
          :scroller="scroller"
          v-validate
          :data-vv-rules="'required'"
          data-vv-name="occupation"
          data-vv-value-path="inputValue"
          :data-vv-as="$t('message.accountPreferencesOccupation')"
          :errorText="errors.first('occupation')"
          :underlineShow="underlineShow"
          :fullWidth="fullWidth"
          :maxHeight="200"
          :hintText="$t('message.selectText')"
          v-model="personalizationModel.occupation_id"
          :label="$t('message.accountPreferencesOccupation')">
          <mu-menu-item
            v-for="(item, index) in lists.occupations"
            :key="'occupation-' + index"
            :value="item.occupation_id"
            :title="localizeOccupation(item.occupation_name)"
          ></mu-menu-item>
        </mu-select-field>
        <mu-select-field
          autoWidth
          :scroller="scroller"
          v-validate
          :data-vv-rules="'required'"
          data-vv-name="dietary_preference"
          data-vv-value-path="inputValue"
          :data-vv-as="$t('message.accountPreferencesDietaryPreference')"
          :errorText="errors.first('dietary_preference')"
          :underlineShow="underlineShow"
          :fullWidth="fullWidth"
          :maxHeight="200"
          :hintText="$t('message.selectText')"
          v-model="personalizationModel.dietry_preference_id"
          :label="$t('message.accountPreferencesDietaryPreference')">
          <mu-menu-item
            v-for="(item, index) in lists.dietry_preferences"
            :key="'diet-pref-' + index"
            :value="item.dietry_preference_id"
            :title="localizeDietPreference(item.name)"
          ></mu-menu-item>
        </mu-select-field>
        <mu-select-field
          :scroller="scroller"
          multiple
          separator=", "
          v-model="personalizationModel.allergies"
          autoWidth
          :fullWidth="fullWidth"
          :maxHeight="370"
          :hintText="$t('message.selectText')"
          :label="$t('message.accountPreferencesAllergies')">
          <mu-menu-item
            v-for="item, index in lists.allergies"
            :key="'allergy-' + index"
            :value="item.allergy_id"
            :title="localizeAllergy(item.name)"
          >
          </mu-menu-item>
        </mu-select-field>
        <input v-if="personalizationModel.currency_code" style="display: none" type="text"
               v-model="personalizationModel.currency_code"/>
        <currency-input
          :currency="currencyCode"
          v-model.number="personalizationModel.weekly_shop_cost"
          :label="$t('message.accountPreferencesShopCost')"
        ></currency-input>
        <br/>
        <mu-raised-button
          class="large"
          @click="submitForm()"
          secondary
          :disabled="isSaving"
          :label="isSaving ? $t('message.updatingText') : $t('message.updateText')"
          fullWidth
        ></mu-raised-button>
      </mu-card-text>
    </div>
    <mu-flexbox v-if="isLoading" justify="center center" align="center center" style="height: 316px;">
      <mu-flexbox-item align="center">
        <mu-circular-progress :size="46"></mu-circular-progress>
        <br/>
        <span v-text="$t('message.loadingText')"></span>
      </mu-flexbox-item>
    </mu-flexbox>

  </div>
</template>
<script>

  import ScrollerMixin from '../../mixins/ScrollerMixin'
  import HCPMixin from '../../mixins/HCPMixin'
  import RegisterReasonLocalizerMixin from '../../mixins/Localization/RegisterReasons'
  import OccupationLocalizerMixin from '../../mixins/Localization/Occupations'
  import AllergyLocalizerMixin from '../../mixins/Localization/Allergies'
  import SexLocalizerMixin from '../../mixins/Localization/Genders'
  import MonthLocalizerMixin from '../../mixins/Localization/DateMonths'
  import DietPreferenceLocalizerMixin from '../../mixins/Localization/DietaryPreferences'
  import EthnicityLocalizerMixin from '../../mixins/Localization/Ethnicity'
  import {getLanguageNativeName, getLanguageName} from '../../mixins/Localization/Languages'


  import LessonApi from '../../api/Lessons'
  import AccountApi from '../../api/Account'

  import UserManager from '../../helpers/UserManager'
  import {Objects} from '../../helpers/Utilities'

  import UpdateHeight from "../../components/Settings/Height/Height";
  import AvatarUploader from "../../components/UploadAvatar/UploadAvatar";
  import CurrencyInput from "../../directives/CurrencyInput.vue";
  import CountryJS from 'country-js'
  import Alert from "../../components/Alert/Alert";
  import ResetAccount from "../../components/ResetAccount/ResetAccount";
  import MobilePhoneInput from "../../components/MobilePhoneInput/MobilePhoneInput";

  const DobObject = Objects.DobObject;

  export default {
    components: {
      MobilePhoneInput,
      ResetAccount,
      Alert,
      CurrencyInput,
      AvatarUploader,
      UpdateHeight,
      DietPreferenceLocalizerMixin,
    },
    name: 'settings-general',
    mixins: [
      ScrollerMixin,
      RegisterReasonLocalizerMixin,
      OccupationLocalizerMixin,
      AllergyLocalizerMixin,
      SexLocalizerMixin,
      MonthLocalizerMixin,
      DietPreferenceLocalizerMixin,
      HCPMixin,
      EthnicityLocalizerMixin
    ],
    data() {
      return {
        title: this.$t('message.accountPreferencesTitle'),
        subTitle: this.$t('message.accountPreferencesSubTitle'),
        isSaving: false,
        isLoading: true,
        fullWidth: true,
        underlineShow: true,
        model: {},
        personalizationModel: {},
        lists: {},
        snackbar: false,
        dobItems: DobObject,
        dob: {
          day: null,
          month: null,
          year: null
        },
        hideNameInputs: false,
      }
    },
    watch: {
        'dob.day': function () {
          let self = this;
          self.formatDateOfBirth();
        },
        'dob.month': function () {
          let self = this;
          self.updateValidDobMonthDays();
          self.formatDateOfBirth();
        },
        'dob.year': function () {
          let self = this;
          self.updateValidDobMonthDays();
          self.formatDateOfBirth();
        }
    },
    mounted() {
      let self = this;
      self.$gtag.pageview('/settings/general');
      self.lists = self.$store.state.list;

      if (this.$store.state.user.scope.use_display_name === true) {
        this.hideNameInputs = true
      }

      AccountApi.getUserPersonalization()
        .then(function (response) {
          self.personalizationModel = response.data;
          self.personalizationModel.currency_code = self.currencyCode.currencyCode;
        });

      AccountApi.getAccount()
        .then(function (response) {
          self.model = response.data;
          if (self.model.dob !== null) {
            let dob = self.model.dob.split('-');
            self.dob.year = self.dobItems.years.find(year => year.value === dob[0]);
            self.dob.month = self.dobItems.months.find(month => month.value === dob[1]);
            self.dob.day = dob[2];
          }
          self.isLoading = false;
        });
    },
    methods: {
      switchInputs() {
        this.hideNameInputs = !this.hideNameInputs;
      },
      getNativeName(key) {
        return getLanguageNativeName(key);
      },
      yearList() {
        let years = 110, yearStartAt = new Date().getFullYear(), yearsArray = [];
        for (let i = 0; i < years; i++) {
          yearsArray.push(yearStartAt--)
        }
        return yearsArray;
      },
      formatDateOfBirth() {
        let self = this;
        if ((!_.isNull(self.dob.day)) && (!_.isNull(self.dob.month)) && (!_.isNull(self.dob.year))) {
          self.model.dob = self.dob.year.value + '-' + self.dob.month.value + '-' + self.dob.day;
        }
      },
      submitForm() {
        let self = this;
        self.$validator.validateAll()
          .then(function (valid) {


            if (self.isOlderThan100 === true) {
              self.$toastr.error("You have to be under 100");
              return;
            }

            if (!self.isValidAge) {
                self.$toastr.error("Age has to be 18 or over");
                self.isSaving = false;
                return;
            }

            if (!valid) {
              self.isSaving = false;
              self.$toastr.error("There were some errors, please check your inputs")
              return;
            }

            self.isSaving = true;
            AccountApi.putAccount(self.model)
              .then(function (response) {
                UserManager.getUserAndStore(self);
                AccountApi.putUserPersonalization(self.personalizationModel).then(function (response) {
                  self.isSaving = false;
                  LessonApi.getLessonsList()
                    .then(function (response) {
                      self.$store.commit('setLessons', response.data);
                      self.$forceUpdate();
                    });
                  self.$toastr.success("Updated account")
                });
              }).catch((error) => {
              if (error.response.data && error.response.data.sub_message && error.response.data.sub_message === "DISPLAY_NAME_UNAVAILABLE") {
                self.$toastr.error("Display name unavailable, please choose a different one")
                self.isSaving = false;
              }
            })
          })
          .catch(function () {
            self.isSaving = false;
            self.$toastr.error("An error occurred updating your account")
          })
      },
      updateValidDobMonthDays() {
        let self = this;
        if (!self.dob.month || !self.dob.month.daysCount) {
          return;
        }

        let days = self.dob.month.daysCount + 1;

        if (!_.isNull(self.dob.year) && self.dob.year.isLeap === true && self.dob.month.value === "02") {
          days = self.dob.month.daysCount + 2;
        }

        let daysArray = [];

        for (let i = 1; i < days; i++) {
          if (i < 10) {
            daysArray.push('0' + i + '')
          } else {
            daysArray.push('' + i + '')
          }
        }

        self.$set(self.dobItems, 'days', daysArray);
      },
    },
    computed: {
      currencyCode() {
        let self = this;
        if (self.$store.state.geoLocation.host != null && self.$store.state.geoLocation.host.country) {
          return CountryJS.search(self.$store.state.geoLocation.host.country)[0].currency;
        }
        return CountryJS.search('GB')[0].currency;
      },
      isValidAge: function() {
        if (this.dob.day && this.dob.month && this.dob.year) {
          let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
          let dob = moment(userDob);
          let ageRestrict = moment().subtract(18, 'years');
          let validAge = moment(dob).isBefore(ageRestrict);
          return validAge;
        }
      },
      isOlderThan100: function() {
        if (this.dob.day && this.dob.month && this.dob.year) {
          let userDob = `${this.dob.year.value}-${this.dob.month.value}-${this.dob.day}`;
          let dob = moment(userDob);
          let ageRestrict = moment().subtract(100, 'years');
          let validAge = moment(dob).isBefore(ageRestrict);
          return validAge;
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// General.vue?492a2c47